/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Credittopupimages3Inputs */

const en_credittopupimages3 = /** @type {(inputs: Credittopupimages3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Enough for about ${i?.count} AI images`)
};

const de_credittopupimages3 = /** @type {(inputs: Credittopupimages3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Reicht für rund ${i?.count} KI-Bilder`)
};

/**
* | output |
* | --- |
* | "Enough for about {count} AI images" |
*
* @param {Credittopupimages3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const credittopupimages3 = /** @type {((inputs: Credittopupimages3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Credittopupimages3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_credittopupimages3(inputs)
	return de_credittopupimages3(inputs)
});
export { credittopupimages3 as "creditTopUpImages" }